import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_ASSESSMENT_TYPE, CURD_ASSESSMENT_EMAIL_TYPE } from "../../utils/routes";

// ---------------------------------------------------------------------

export const createassessmentType = createAsyncThunk(
  "assessmentType/createassessmentType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_ASSESSMENT_TYPE, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getassessmentType = createAsyncThunk(
  "assessmentType/getassessmentType",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_ASSESSMENT_TYPE, { withCredentials: true });
      return response;
    } catch(err) {
      return rejectWithValue(err.response)
    }
  }
);

export const getassessmentEmailType = createAsyncThunk(
  "assessmentType/getassessmentEmailType",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_ASSESSMENT_EMAIL_TYPE, { withCredentials: true });
      return response;
    } catch(err) {
      return rejectWithValue(err.response)
    }
  }
);

export const updateassessmentType = createAsyncThunk(
  "assessmentType/updateassessmentType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_ASSESSMENT_TYPE, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteassessmentType = createAsyncThunk(
  "assessmentType/deleteassessmentType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_ASSESSMENT_TYPE, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const assessmentTypeSlice = createSlice({
  name: "assessmentType",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    assessmentTypeData: [],
    assessmentEmailData:[],
    // state variable for setting the data assessment type 
    assessmentType: null,
    selectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
    // set variable for setting the assessment type
    setAssessmentType: (state, action) => {
      state.assessmentType = action.payload;
    },
  },
  extraReducers: {
    [createassessmentType.pending]: (state, action) => {
      state.loading = true;
    },
    [createassessmentType.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createassessmentType.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getassessmentType.pending]: (state, action) => {
      state.loading = true;
    },
    [getassessmentType.fulfilled]: (state, action) => {
      state.loading = false;
      state.assessmentTypeData = action?.payload?.data;
    },
    [getassessmentType.rejected]: (state, action) => {
      
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },

    [getassessmentEmailType.pending]: (state, action) => {
      state.loading = true;
    },
    [getassessmentEmailType.fulfilled]: (state, action) => {
      state.loading = false;
      state.assessmentEmailData = action?.payload?.data;
    },
    [getassessmentEmailType.rejected]: (state, action) => {
      
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },


    [updateassessmentType.pending]: (state, action) => {
      state.loading = true;
    },
    [updateassessmentType.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateassessmentType.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteassessmentType.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteassessmentType.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteassessmentType.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect ,setAssessmentType} =
  assessmentTypeSlice.actions;
export default assessmentTypeSlice.reducer;
